import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LoginTypeEnum } from '../enums/loginType.enum';
import { AuthenticationService } from '../services/authentication.service';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const authenticationService = inject(AuthenticationService);
    const userService = inject(UserService);

    if (req.url.indexOf('/assets') === -1 && req.url.indexOf('/config') == -1) {
      if (environment.loginType === LoginTypeEnum.Windows) {
        req = req.clone({
          url: req.url,
          withCredentials: true, // windows authentication
        });

        return next.handle(req);
      } else {
        const accessToken: string = authenticationService.getToken();

        if (accessToken) {
          req = this.addToken(req, accessToken);
        }

        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (
              error.status === HttpStatusCode.Unauthorized &&
              !this.isRefreshing
            ) {
              this.isRefreshing = true;
              const refreshToken = authenticationService.getRefreshToken();
              return userService.refreshToken(refreshToken).pipe(
                switchMap((data: HttpResponse<any>) => {
                  this.isRefreshing = false;
                  const token = data.body.result as string;
                  req = this.addToken(req, token);
                  authenticationService.storeAccessToken(token);
                  return next.handle(req);
                }),
                catchError((err) => {
                  this.isRefreshing = false;
                  authenticationService.logout();
                  return throwError(() => err);
                }),
              );
            } else {
              return throwError(() => error);
            }
          }),
        );
      }
    } else {
      return throwError(() => 'error');
    }
  }

  private addToken(req: HttpRequest<any>, token: string) {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
